import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getApiService = () => `${apiUtils.getBaseUri()}`;

const changePassword = async (oldPassword, newPassword, userId) => {
    const uri = `${getApiService(userId)}/users/${userId}/password`;

    const response = await HTTPClient().putJson(uri, {
        oldPassword,
        newPassword,
    });

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

export default {
    changePassword,
};
